export const industries = {
    common: {
        eyebrow: "{{name}} জন্য",
        challenges: "যেখানে আটকে যায়",
        youGet: "যা পাবেন",
        themesTitle: "{{name}} জন্য ওয়েবসাইট ডিজাইন",
        themesBody: "আপনার মতো দোকানের জন্য বানানো ডিজাইন দিয়ে শুরু করুন। প্রতিটিই একটি আসল, চালু ডেমো দোকান।",
        featuresTitle: "এরপর যা দেখবেন",
    },
    fashion: {
        name: "ফ্যাশন দোকানের",
        nav: "ফ্যাশন",
        metaDescription: "বাংলাদেশের পোশাক ও ফ্যাশন দোকানের জন্য: দোকান, ফেসবুক আর ওয়েবসাইটে প্রতিটি সাইজ আর রঙের একটাই স্টক, কুরিয়ার আর COD এক জায়গায়।",
        title: "প্রতিটি সাইজ আর রং, দোকানে আর অনলাইনে ঠিকঠাক",
        body: "একই কুর্তি কাউন্টারে, ফেসবুকে আর ওয়েবসাইটে বিক্রি করুন — শেষ মিডিয়াম সাইজটি দুবার বিক্রি হবে না।",
        challenges: {
            a: {
                title: "সাইজ আর রং অসমভাবে শেষ হয়",
                body: "প্রতিটি সাইজ আর রঙের স্টক, প্রতিটি ব্রাঞ্চে লাইভ, আর জনপ্রিয়গুলো শেষ হওয়ার আগেই কম স্টকের সতর্কবার্তা।",
            },
            b: {
                title: "ফেসবুকের অর্ডার আর রিটার্ন জমে যায়",
                body: "সব চ্যানেলের এক অর্ডার তালিকা, এক ক্লিকে কুরিয়ার বুকিং, আর রিটার্ন-এক্সচেঞ্জে স্টক ফিরে আসে।",
            },
            c: {
                title: "ঈদের ভিড়ে কাউন্টার",
                body: "দ্রুত বিল করা আর অফলাইনেও চলা POS, রসিদ থেকেই এক্সচেঞ্জ।",
            },
        },
        points: {
            p1: "সাইজ, রং আর কাপড়ের ভ্যারিয়েন্ট, প্রত্যেকটির নিজের বারকোড",
            p2: "প্রোডাক্ট পেজে সাইজ চার্ট",
            p3: "পাঠানোর আগে ভুয়া অর্ডার যাচাই",
            p4: "প্রোডাক্ট আর চ্যানেল অনুযায়ী লাভ",
        },
    },
    grocery: {
        name: "মুদি দোকানের",
        nav: "মুদি",
        metaDescription: "মুদি ও সুপার শপের জন্য: অফলাইনেও চলা দ্রুত বারকোড বিল, ওজনে বিক্রি, দোকান বন্ধ না করেই স্টক গণনা, আর নিজের ওয়েবসাইট থেকে হোম ডেলিভারি।",
        title: "ব্যস্ত কাউন্টার, যা ইন্টারনেটের জন্য অপেক্ষা করে না",
        body: "বারকোড বা ওজনে ঘণ্টায় শত শত আইটেম বিল করুন, আর একই স্টক থেকে হোম ডেলিভারির অর্ডার নিন।",
        challenges: {
            a: {
                title: "সন্ধ্যায় লম্বা লাইন",
                body: "স্ক্যান, খোলা মালের কুইক কি আর পরিমাণ গুণক লাইন চলমান রাখে; POS কখনো নেটের জন্য থামে না।",
            },
            b: {
                title: "হাজারো আইটেম, অল্প লাভ",
                body: "পারচেজ অর্ডার, সাপ্লায়ারের বাকি আর প্রতিটি প্রোডাক্টের লাভ দেখায় লাভ কোথায় যাচ্ছে।",
            },
            c: {
                title: "স্টক গুনতে দোকান বন্ধ",
                body: "বিক্রি চলতে চলতেই তাক গুনুন; গণনার সময়ের বিক্রিও হিসাবে ধরা হয়।",
            },
        },
        points: {
            p1: "ওজন বা পিস হিসেবে বিক্রি",
            p2: "নিজের প্যাকের বারকোড লেবেল",
            p3: "হোম ডেলিভারির জন্য ডেলিভারি জোন আর চার্জ",
            p4: "প্রতিটি ক্যাশিয়ারের শিফটের ক্যাশ গণনা",
        },
    },
    cosmetics: {
        name: "বিউটি ও কসমেটিকস দোকানের",
        nav: "কসমেটিকস",
        metaDescription: "বিউটি ও কসমেটিকস বিক্রেতাদের জন্য: ফেসবুক বিজ্ঞাপনের ল্যান্ডিং পেজ, পিক্সেল ও কনভার্সন API, ভুয়া অর্ডার যাচাই, COD মিলানো আর দোকান-অনলাইনের এক স্টক।",
        title: "হিসাব না হারিয়ে ফেসবুক বিজ্ঞাপন থেকে বিক্রি",
        body: "বিজ্ঞাপন থেকে ল্যান্ডিং পেজে আনুন, অর্ডার নিন, আসল কিনা যাচাই করুন আর কুরিয়ারে পাঠান — দোকানের স্টকও ঠিক থাকে।",
        challenges: {
            a: {
                title: "বিজ্ঞাপন অর্ডার আনে, ভুয়া অর্ডারও",
                body: "প্রতিটি ফোন নম্বরের ইতিহাস থেকে ঝুঁকির স্কোর, আর পার্সেল ফেরত দেওয়া নম্বরের ব্লকলিস্ট।",
            },
            b: {
                title: "কোন বিজ্ঞাপনে বিক্রি হয়, জানা যায় না",
                body: "আপনার দোকানে ফেসবুক পিক্সেল আর কনভার্সন API, প্রতিটি অর্ডার একবারই গোনা হয়।",
            },
            c: {
                title: "COD-এর টাকা ভেঙে ভেঙে আসে",
                body: "কুরিয়ারের পেমেন্ট অর্ডারের সাথে মিলানো, তাই কত বাকি তা দেখা যায়।",
            },
        },
        points: {
            p1: "পেজের মধ্যেই অর্ডার ফর্ম সহ ল্যান্ডিং পেজ",
            p2: "অফার আর কুপন",
            p3: "এক ক্লিকে স্টেডফাস্ট, পাঠাও বা রেডএক্স",
            p4: "দোকান আর অনলাইনের একটাই স্টক",
        },
    },
    gadgets: {
        name: "গ্যাজেট ও ইলেকট্রনিক্স দোকানের",
        nav: "গ্যাজেট",
        metaDescription: "মোবাইল, গ্যাজেট ও ইলেকট্রনিক্স দোকানের জন্য: ব্রাঞ্চভিত্তিক স্টক, পারচেজ অর্ডার ও সাপ্লায়ারের বাকি, অনলাইনে বিস্তারিত স্পেসিফিকেশন আর প্রতিটি আইটেমের সঠিক লাভ।",
        title: "দামি স্টক, শেষ পিস পর্যন্ত গোনা",
        body: "প্রতিটি ফোন আর চার্জার কোথায় আছে, কত দামে কেনা আর কত লাভ হলো — প্রতিটি ব্রাঞ্চে আর অনলাইনে জানুন।",
        challenges: {
            a: {
                title: "ব্রাঞ্চে ব্রাঞ্চে দামি স্টক",
                body: "ব্রাঞ্চভিত্তিক লাইভ স্টক, পাঠানো-গ্রহণের ধাপ সহ ট্রান্সফার আর প্রতিটি পরিবর্তনের ইতিহাস।",
            },
            b: {
                title: "দ্রুত বিক্রি হওয়া আইটেমে কম লাভ",
                body: "খরচ বাদে প্রতিটি আইটেমের লাভ, আর এক নজরে সাপ্লায়ারের বাকি।",
            },
            c: {
                title: "কাস্টমার অনলাইনে স্পেক মিলিয়ে দেখে",
                body: "গ্যাজেট ডিজাইনে পূর্ণ স্পেসিফিকেশন আর সম্পর্কিত প্রোডাক্ট সহ প্রোডাক্ট পেজ।",
            },
        },
        points: {
            p1: "পারচেজ অর্ডার আর মাল গ্রহণ",
            p2: "মাল আসার সাথে সাথে বারকোড লেবেল",
            p3: "রসিদ থেকে রিটার্ন আর এক্সচেঞ্জ",
            p4: "ভ্যাট ইনভয়েস",
        },
    },
    jewellery: {
        name: "জুয়েলারি দোকানের",
        nav: "জুয়েলারি",
        metaDescription: "জুয়েলারি দোকানের জন্য: দামি প্রতিটি পিসের যত্নশীল স্টক, ছাড়ে ম্যানেজারের অনুমোদন, প্রতি শিফটে ক্যাশ গণনা আর রুচিশীল ওয়েবসাইট ডিজাইন।",
        title: "প্রতিটি পিসের হিসাব আছে",
        body: "দামি স্টক, সাবধানী ছাড় আর প্রতিটি শিফট শেষে ভরসার ক্যাশ গণনা।",
        challenges: {
            a: {
                title: "একটি পিস হারালেই বড় ক্ষতি",
                body: "প্রতিটি আইটেমের ইতিহাস — গ্রহণ, স্থানান্তর, বিক্রি বা অ্যাডজাস্ট — কে করেছে সহ।",
            },
            b: {
                title: "কাউন্টারে ছাড়",
                body: "আপনার সীমার বেশি ছাড়ে ম্যানেজারের PIN লাগে, আর প্রতিটি ছাড় রিপোর্টে দেখা যায়।",
            },
            c: {
                title: "দিন শেষে ক্যাশ",
                body: "শিফট শুরু হয় হাতের ক্যাশ দিয়ে আর শেষ হয় না-দেখে গণনায়, পার্থক্য সাথে সাথেই দেখায়।",
            },
        },
        points: {
            p1: "রুচিশীল জুয়েলারি ওয়েবসাইট ডিজাইন",
            p2: "গুরুত্বপূর্ণ পরিবর্তনের অডিট ট্রেইল",
            p3: "প্রতিটি পিসের লাভ",
            p4: "বাংলা রসিদ আর ইনভয়েস",
        },
    },
    bookshop: {
        name: "বইয়ের দোকানের",
        nav: "বইয়ের দোকান",
        metaDescription: "বইয়ের দোকান ও প্রকাশকদের জন্য: ছাপা বই আর ই-বুক পাশাপাশি, লেখক ও প্রকাশকের পেজ, বাংলাকে প্রাধান্য দেওয়া ডিজাইন, কাউন্টারের POS আর কুরিয়ার ডেলিভারি।",
        title: "ছাপা বই আর ই-বুক, এক দোকানে",
        body: "কাউন্টারে বিক্রি করুন, ছাপা বই কুরিয়ারে পাঠান, আর পাঠক টাকা দেওয়ার সাথে সাথেই ই-বুক পড়া শুরু করুক।",
        challenges: {
            a: {
                title: "হাজার হাজার বই",
                body: "লেখক, প্রকাশক আর ক্যাটাগরি, বাংলা ও ইংরেজিতে খোঁজা যায়।",
            },
            b: {
                title: "পাঠক ই-বুকও চান",
                body: "যেকোনো বইয়ে ই-বুক সংস্করণ যোগ করুন, ফ্রি নমুনা আর প্রতিটি কাস্টমারের পড়ার লাইব্রেরি সহ।",
            },
            c: {
                title: "বইমেলা আর কাউন্টার",
                body: "স্টলে অফলাইনেও চলা POS, নেট ফিরলে সিঙ্ক হয়।",
            },
        },
        points: {
            p1: "বইঘর বইয়ের দোকানের ডিজাইন",
            p2: "ই-বুকের জন্য বিকাশ পেমেন্ট",
            p3: "ওয়াটারমার্ক করা পাতা",
            p4: "ছাপা বইয়ের কুরিয়ার ডেলিভারি",
        },
    },
    "home-kitchen": {
        name: "হোম ও কিচেন দোকানের",
        nav: "হোম ও কিচেন",
        metaDescription: "হোম, কিচেন ও ফার্নিচার বিক্রেতাদের জন্য: এলাকা আর ওজন অনুযায়ী ডেলিভারি চার্জ, কুরিয়ার বুকিং, এক প্রোডাক্টের ল্যান্ডিং পেজ আর সব ব্রাঞ্চে এক স্টক।",
        title: "বড় জিনিস, ঠিকঠাক ডেলিভারি",
        body: "এলাকা অনুযায়ী ডেলিভারি চার্জ নিন, অর্ডার থেকেই কুরিয়ার বুক করুন আর দোকান ও ওয়েবসাইট এক স্টকে রাখুন।",
        challenges: {
            a: {
                title: "এলাকাভেদে ডেলিভারি খরচ আলাদা",
                body: "নিজস্ব চার্জ আর ডেলিভারির দিন সহ ডেলিভারি জোন, অর্ডারের আগেই কাস্টমার দেখতে পান।",
            },
            b: {
                title: "একটি প্রোডাক্টই সবচেয়ে বেশি বিক্রি হয়",
                body: "তার জন্য একটি ল্যান্ডিং পেজ, পেজেই অর্ডার ফর্ম আর অফার।",
            },
            c: {
                title: "গুদামে আর দোকানে স্টক",
                body: "প্রতিটি জায়গার লাইভ স্টক আর তাদের মধ্যে ট্রান্সফার।",
            },
        },
        points: {
            p1: "হোম ও কিচেন ডিজাইন",
            p2: "কুরিয়ার বুকিং আর COD মিলানো",
            p3: "পারচেজ অর্ডার আর সাপ্লায়ারের বাকি",
            p4: "প্রোডাক্ট অনুযায়ী লাভ",
        },
    },
    kids: {
        name: "শিশু ও বেবি পণ্যের দোকানের",
        nav: "শিশু ও বেবি",
        metaDescription: "শিশু ও বেবি পণ্যের দোকানের জন্য: বয়স আর সাইজের ভ্যারিয়েন্ট, উপহারের অফার, ফেসবুক অর্ডার আর একই স্টকে প্রাণবন্ত ওয়েবসাইট ডিজাইন।",
        title: "বয়স অনুযায়ী সাইজ, স্টক থাকে ঠিক",
        body: "পোশাক, খেলনা আর বেবি কেয়ার — বয়স আর সাইজের ভ্যারিয়েন্ট সহ দোকানে, ফেসবুকে আর ওয়েবসাইটে বিক্রি করুন।",
        challenges: {
            a: {
                title: "শিশু বড় হয়, সাইজ বদলায়",
                body: "বয়স আর সাইজের ভ্যারিয়েন্ট, প্রত্যেকটির নিজের স্টক, আর বেশি বিক্রি হওয়াগুলোর কম স্টকের সতর্কবার্তা।",
            },
            b: {
                title: "বাবা-মা ফোন থেকে অর্ডার করেন",
                body: "প্রাণবন্ত, দ্রুত ওয়েবসাইট ডিজাইন, আর ফেসবুকের অর্ডার একই তালিকায়।",
            },
            c: {
                title: "উপহার আর রিটার্ন",
                body: "রসিদ থেকেই এক্সচেঞ্জ, স্টক ফিরে আসে।",
            },
        },
        points: {
            p1: "শিশু ও বেবি ডিজাইন",
            p2: "অফার আর কুপন",
            p3: "এক ক্লিকে কুরিয়ার বুকিং",
            p4: "দোকান আর অনলাইনের একটাই স্টক",
        },
    },
};
export const themesPage = {
    metaTitle: "ওয়েবসাইট থিম",
    metaDescription: "বাংলাদেশি ব্যবসার জন্য বানানো ১২টি অনলাইন দোকানের ডিজাইন — ফ্যাশন, মুদি, গ্যাজেট, বই, বিউটি আর আরও। প্রতিটি চালু ডেমো দোকান হিসেবে খুলে দেখুন।",
    eyebrow: "ওয়েবসাইট থিম",
    title: "বাংলাদেশি দোকানের জন্য ১২টি ডিজাইন",
    body: "প্রতিটি ডিজাইনই একটি আসল, চালু ডেমো দোকান। একটি খুলুন, কার্টে কিছু যোগ করুন, আর দেখুন আপনার কাস্টমার কীভাবে কেনাকাটা করবেন।",
    visit: "চালু ডেমো খুলুন",
    preview: "প্রিভিউ",
    shotAlt: "কম্পিউটারে {{name}} থিম",
    phoneAlt: "ফোনে {{name}} থিম",
    ctaTitle: "আপনার দোকান, আপনার ডিজাইনে",
    ctaBody: "ফ্রিতে শুরু করুন, একটি ডিজাইন বাছুন আর আজই প্রকাশ করুন। পরে বদলালেও কিছু হারাবে না।",
    descriptions: {
        fashion_women: "বড় ছবি, সাইজ বাছাই আর সামনেই অফার — মেয়েদের পোশাক আর শাড়ির জন্য।",
        fashion_men: "পাঞ্জাবি, শার্ট আর ছেলেদের পোশাকের জন্য পরিষ্কার, সাহসী লেআউট।",
        cosmetics: "কোমল আর উজ্জ্বল, বিউটি প্রোডাক্ট আর স্কিন কেয়ারের জন্য।",
        gadgets: "স্পেক, তুলনা আর সম্পর্কিত আইটেম — ফোন আর ইলেকট্রনিক্সের জন্য।",
        grocery: "ক্যাটাগরি ধরে দ্রুত দেখা যায়, ওজন আর প্যাকের সাইজ সহ।",
        home_kitchen: "ঘর ধরে ধরে — হোম, কিচেন আর ফার্নিচারের জন্য।",
        kids_baby: "প্রাণবন্ত আর সহজ — পোশাক, খেলনা আর বেবি কেয়ারের জন্য।",
        jewellery: "রুচিশীল আর শান্ত, প্রতিটি পিস আলাদা করে ফুটে ওঠে।",
        home_food: "উষ্ণ আর ঘরোয়া — ঘরে রান্না আর খাবারের ব্যবসার জন্য।",
        books: "বইঘর: বাংলাকে প্রাধান্য দিয়ে, লেখক, প্রকাশক আর ই-বুক সহ।",
        single_product: "একটি প্রোডাক্ট, একটি পেজ, অর্ডার ফর্ম সহ — বিজ্ঞাপনের জন্য।",
        minimal: "সাধারণ আর শান্ত, যেকোনো দোকানে মানায়।",
    },
};
export const hardware = {
    metaTitle: "হার্ডওয়্যার",
    metaDescription: "{{brand}} POS চালাতে যা লাগে: উইন্ডোজ বা ম্যাক কম্পিউটার, ৫৮ বা ৮০ মিমি থার্মাল প্রিন্টার, USB বারকোড স্ক্যানার, ক্যাশ ড্রয়ার আর লেবেল প্রিন্টার।",
    eyebrow: "হার্ডওয়্যার",
    title: "দোকানে যে হার্ডওয়্যার আগে থেকেই আছে, তাতেই চলে",
    body: "বিশেষ কোনো মেশিন লাগে না। শুরু করতে একটি সাধারণ কম্পিউটার, থার্মাল প্রিন্টার আর বারকোড স্ক্যানারই যথেষ্ট; দরকার হলে ক্যাশ ড্রয়ার আর লেবেল প্রিন্টার যোগ করুন।",
    soldSeparately: "হার্ডওয়্যার আলাদাভাবে কিনতে হয়। কেনার আগে আমাদের জিজ্ঞেস করুন, কোন মডেলগুলো আমরা পরীক্ষা করেছি জানিয়ে দেব।",
    ask: "হোয়াটসঅ্যাপে জিজ্ঞেস করুন",
    askForm: "আমাদের বার্তা পাঠান",
    items: {
        computer: {
            title: "কম্পিউটার",
            body: "কাউন্টারের কম্পিউটারে POS চলে।",
            points: {
                p1: "উইন্ডোজ ১০ বা তার পরের ভার্সন, অথবা ম্যাক",
                p2: "কমপক্ষে ১৩৬৬ × ৭৬৮ স্ক্রিন",
                p3: "টাচ স্ক্রিনেও চলে, তবে লাগবেই এমন নয়",
            },
        },
        printer: {
            title: "রসিদ প্রিন্টার",
            body: "যেকোনো সাধারণ থার্মাল প্রিন্টারে বাংলা রসিদ প্রিন্ট হয় — রসিদ ছবি হিসেবে যায়, তাই প্রিন্টারে বাংলা ফন্ট লাগে না।",
            points: {
                p1: "৫৮ মিমি বা ৮০ মিমি থার্মাল কাগজ",
                p2: "USB বা নেটওয়ার্ক (ESC/POS)",
                p3: "ক্যাশ ড্রয়ারও খোলে",
            },
        },
        scanner: {
            title: "বারকোড স্ক্যানার",
            body: "কিবোর্ডের মতো টাইপ করে এমন যেকোনো স্ক্যানার কোনো সেটআপ ছাড়াই চলে।",
            points: {
                p1: "USB বা ব্লুটুথ",
                p2: "EAN-13, UPC-A আর Code 128 পড়ে",
                p3: "স্টক গণনাতেও কাজে লাগে",
            },
        },
        drawer: {
            title: "ক্যাশ ড্রয়ার",
            body: "রসিদ প্রিন্টারের সাথে লাগানো থাকে, ক্যাশ বিক্রি শেষ হলে খুলে যায়।",
            points: {
                p1: "প্রিন্টারের সাথে সংযোগ (RJ11)",
                p2: "বিক্রি ছাড়া খুলতে ম্যানেজার লাগে",
                p3: "প্রতিটি শিফট শেষে গোনা হয়",
            },
        },
        labels: {
            title: "বারকোড লেবেল",
            body: "প্রোডাক্টের দাম আর বারকোডের স্টিকার প্রিন্ট করুন — A4 স্টিকার শিটে বা লেবেল প্রিন্টারের রোলে।",
            points: {
                p1: "নাম, দাম, MRP আর বারকোড",
                p2: "৩৮ × ২৫ মিমি লেবেল নির্ভরযোগ্যভাবে স্ক্যান হয়",
                p3: "মাল গ্রহণের পরপরই প্রিন্ট করুন",
            },
        },
    },
};
//# sourceMappingURL=web-solutions.js.map